import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-testlist-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './projects-testlist-index-page.component.html',
  styleUrl: './projects-testlist-index-page.component.scss'
})
export class ProjectsTestlistIndexPageComponent {
list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected projectsService: ProjectsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Testlist',
      cardTitle: 'Manage Testlist',
      addNewItemButton: {
        type: 'success',
        title: 'Add Testlist',
        onClick: () => {
          this.routeService.projectsSettingsTestlistCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'testName',
            header: 'Test Name',
            filter: 'text',
            value: (item: any) => {
              return item?.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'jurisdictionId',
            header: 'Jurisdiction',
            filter: 'select',            
            filterOptionsSource: 'jurisdaction',
            value: (item: any) => {
              return item?.jurisdiction?.name;
            }
          }),          
          new DataTableColumnText({
            attribute: 'relatedChecklist',
            header: 'Related Checklist',
            filter: 'text',
            value: (item: any) => {
              return item.testlistJoinRegulationList?.checklist?.name;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View chechlist details',
                onClick: (item: any) => {
                  this.routeService.projectsSettingsTestlistDetail(item.testlistId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit chechlist',
                onClick: (item: any) => {
                  this.routeService.projectsSettingsTestlistUpdate(item.testlistId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete category',
                onClick: (item: any) => {
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.projectsService.listSettingsTestlist(options),
      responseListModelName: 'testlists',
    }
  }
}
